import { Autocomplete, Grid, TextField, Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import { buscarComboPorCodigo } from "../../services/api-autenticacao.service";

const AutoCompleteGenericGrupoECnpj = ({ onChange, multiple }) => {
  const [msg, setMsg] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const noOptionText = "Sem Opções";

  const [grupoList, setGrupoList] = useState([{}]);
  const [grupoValue, setGrupoValue] = useState(null);
  const [cnpjList, setCnpjList] = useState([{}]);
  const [cnpjFilter, setCnpjFilter] = useState([{}]);
  const [cnpjValue, setCnpjValue] = useState(multiple ? [] : null);
  const [ids, setIds] = useState({ GE: null, CNPJ: null });

  const handleOpenSnackbarErro = () => setOpenSnackbarErro(true);
  const handleCloseSnackbarErro = (event, reason) => {
    if (reason !== "clickaway") {
      setOpenSnackbarErro(false);
    }
  };

  const handleCnpjMultiple = (item) => {
    const split = item.split("-");
    return `${split[0]}-${split[1]}`;
  };

  const handleItensGeneric = (response, codCombo) => {
    const itensGenericList = response.detalhes.itensCombo.map((item) => {
      const splitValues = item.split("/|/");
      return {
        id: splitValues[0],
        label:
          codCombo === "CNPJ" && multiple
            ? handleCnpjMultiple(splitValues[1])
            : splitValues[1],
        codCombo: codCombo,
        codGrupo: codCombo === "CNPJ" ? splitValues[2] : null,
      };
    });

    if (codCombo === "CNPJ") {
      setCnpjList(itensGenericList);
    } else if (codCombo === "GRUPOECONOMICO") {
      setGrupoList(itensGenericList);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseGrupo = await buscarComboPorCodigo("GRUPOECONOMICO");
        const responseCnpj = await buscarComboPorCodigo("CNPJ");
        handleItensGeneric(responseGrupo, "GRUPOECONOMICO");
        handleItensGeneric(responseCnpj, "CNPJ");
      } catch (err) {
        const errorMessage = err.response
          ? err.response.mensagem
          : "Erro: Tente novamente!";
        setMsg(errorMessage);
        handleOpenSnackbarErro();
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    onChange && onChange(ids);
  }, [ids]);

  useEffect(() => {
    if (multiple && cnpjFilter.length > 0) {
      setCnpjValue(cnpjFilter);
      setIds((prevIds) => ({
        ...prevIds,
        CNPJ: cnpjFilter.map((item) => item.id),
      }));
    }
  }, [cnpjFilter, multiple]);

  const handleGrupoChange = (e, value) => {
    setCnpjValue(multiple ? [] : null);
    if (value) {
      const selectedGrupo = grupoList.find((option) => option.id === value.id);
      setGrupoValue(selectedGrupo);
      setIds({ CNPJ: null, GE: value.id, nome_CNPJ: null, nome_GE: value.label });
      const listaCnpj = cnpjList.filter((item) => item.codGrupo === value.id);
      setCnpjFilter(listaCnpj);
    } else {
      setGrupoValue(null);
      setIds({ CNPJ: null, GE: null, nome_CNPJ: null, nome_GE: null });
    }
  };

  const handleCnpjChange = (e, value) => {
    if (value) {
      if (multiple) {
        const listIdCNPJ = value.map((item) => item.id);
        const listNomesCNPJ = value.map((item) => item.label);
        setCnpjValue(value);
        setIds({ ...ids, CNPJ: listIdCNPJ, nome_CNPJ: null, nomes_CNPJ: listNomesCNPJ });
      } else {
        setCnpjValue(value);
        setIds({ ...ids, CNPJ: value.id, nome_CNPJ: value.label, nomes_CNPJ: null });
      }
    } else {
      setCnpjValue(multiple ? [] : null);
      setIds({ ...ids, CNPJ: null, nome_CNPJ: null, nomes_CNPJ: null });
    }
  };

  const formatLabel = (input, textForm = false) => {
    if (!input) return;

    const [firstHalf, secondHalf] = input.split("-", 2);

    let formattedFirstHalf;
    if (firstHalf.length === 11) {
      formattedFirstHalf = firstHalf.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4"
      );
    } else if (firstHalf.length === 14) {
      formattedFirstHalf = firstHalf.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    } else {
      formattedFirstHalf = firstHalf;
    }

    if (textForm) {
      return `${formattedFirstHalf} - ${secondHalf}`;
    } else {
      return <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{fontWeight: 'bold'}}>{formattedFirstHalf}</span>
        <span style={{fontSize: '90%'}}>{secondHalf}</span>
      </div>;
    }
  };

  return (
    <Grid container spacing={1} sx={{ display: "flex", flexDirection: "row" }}>
      <Grid item xs={multiple ? 12 : 6}>
        <Autocomplete
          renderInput={(params) => (
            <TextField {...params} label="Grupo Econômico" variant="standard" />
          )}
          fullWidth
          size="small"
          options={grupoList}
          value={grupoValue}
          noOptionsText={noOptionText}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionKey={(option) => option.id}
          getOptionLabel={(option) => option.label}
          onChange={handleGrupoChange}
          renderOption={(props, option, { selected }) =>
            <li {...props} key={option.id} style={{textWrap: 'wrap'}}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{fontSize: '90%'}}>{option.label}</span>
              </div>
            </li>
          }
        />
      </Grid>
      <Grid item xs={multiple ? 12 : 6}>
        <Autocomplete
          renderInput={(params) => (
            <TextField {...params} label="CNPJ" variant="standard" />
          )}
          disabled={!grupoValue}
          fullWidth
          size="small"
          limitTags={2}
          options={cnpjFilter}
          multiple={multiple}
          disableCloseOnSelect={multiple}
          noOptionsText={noOptionText}
          value={cnpjValue}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionKey={(option) => option.id}
          getOptionLabel={(option) => formatLabel(option.label, true)}
          onChange={handleCnpjChange}
          renderOption={(props, option, { selected }) =>
            multiple ? (
              <li {...props} key={option.id} style={{textWrap: 'wrap'}}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {formatLabel(option.label)}
              </li>
            ) : (
              <li {...props} key={option.id} style={{textWrap: 'wrap'}}>
                {formatLabel(option.label)}
              </li>
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default AutoCompleteGenericGrupoECnpj;
